import { avatarColors, avatarTones, kindTones, occasionKind } from './avatar';
import { breakpoints } from './breakpoints';
import { hueDescriptions, palette } from './color';
import { duration, easing } from './motion';
import { radius } from './radius';
import { confettiColors, contrastPairs, semantic, semanticUsage } from './semantic';
import { shadow } from './shadow';
import { pageGutter, size, space } from './space';
import { fontFamily, fontWeight, googleFontsHref, textStyles } from './typography';
import { zIndex } from './zIndex';

/** The whole design system as data. `/styles` renders from this; tokens.css is generated from it. */
export const tokens = {
  palette,
  hueDescriptions,
  semantic,
  semanticUsage,
  contrastPairs,
  confettiColors,
  fontFamily,
  fontWeight,
  googleFontsHref,
  textStyles,
  space,
  size,
  pageGutter,
  radius,
  shadow,
  duration,
  easing,
  zIndex,
  breakpoints,
  occasionKind,
  kindTones,
  avatarColors,
  avatarTones,
} as const;

export type Tokens = typeof tokens;

export { cssVar, varName } from './cssVar';
export { contrastRatio, luminance, AA } from './contrast';
export { resolveColor } from './color';
export type { ColorRef, HueName } from './color';
export type { ContrastPair, ThemedColor } from './semantic';
export type { TextStyleName } from './typography';
export type { SpaceKey } from './space';
export { avatarColors, avatarTones, kindTones } from './avatar';
export type { OccasionKind, AvatarColor } from './avatar';
export type { Breakpoint } from './breakpoints';
export { mediaQuery } from './breakpoints';
export { resolveSemantic, flattenSemantic } from './resolve';
